import React from 'react';
import { Box, keyframes } from '@mui/material';
import { Message } from './types';
import { ChatMessage } from './ChatMessage';

interface ChatHistoryProps {
  messages: Message[];
  isLoading: boolean;
}

const dotAnimation = keyframes`
  0%, 20% { opacity: 0.3; }
  50% { opacity: 1; }
  100% { opacity: 0.3; }
`;

export const ChatHistory: React.FC<ChatHistoryProps> = ({ messages, isLoading }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
    {messages.map((msg, idx) => (
      <ChatMessage key={idx} message={msg} />
    ))}
    {isLoading && (
      <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
        <Box sx={{ px: 2, py: 1.5, borderRadius: '8px', bgcolor: '#f3f4f6', display: 'flex', gap: 0.5 }}>
          <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: '#9ca3af', animation: `${dotAnimation} 1.4s infinite`, animationDelay: '0s' }} />
          <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: '#9ca3af', animation: `${dotAnimation} 1.4s infinite`, animationDelay: '0.2s' }} />
          <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: '#9ca3af', animation: `${dotAnimation} 1.4s infinite`, animationDelay: '0.4s' }} />
        </Box>
      </Box>
    )}
  </Box>
);
